import { Agent as HTTPAgent } from 'http';
import { Agent as HTTPSAgent } from 'https';

import axios, { type AxiosInstance } from 'axios';
import { type GetServerSidePropsContext } from 'next';
import { evolve, when } from 'ramda';

import { camelizeKeys, decamelizeKeys } from '@framework/utils/camelize.utils';

import { type NextPageContext } from '@type/next';

import { excludeKeys, shouldCamelizeResponse } from './utils';

const axiosServerCreator = (ctx: NextPageContext | GetServerSidePropsContext): AxiosInstance => {
    const axiosServer = axios.create({
        httpAgent: new HTTPAgent({ keepAlive: false }),
        httpsAgent: new HTTPSAgent({ keepAlive: false })
    });

    axiosServer.interceptors.response.use(
        when(shouldCamelizeResponse, evolve({ data: (data) => camelizeKeys(data, excludeKeys) }))
    );

    axiosServer.interceptors.request.use(
        evolve({ data: decamelizeKeys, params: decamelizeKeys }),
        (error) => Promise.reject(error)
    );

    const reqHeaders = (ctx.req?.headers as Record<string, string>) || {};
    const headers = {
        ...reqHeaders,
        referer: `https://${reqHeaders['x-forwarded-host']}`,
        'X-CSRFToken': ctx.req?.cookies?.csrftoken || '',
        'X-Sherpany-Node-Server': 'true'
    };

    axiosServer.defaults.headers.common = {
        ...axiosServer.defaults.headers.common,
        ...headers
    };

    return axiosServer;
};

export default axiosServerCreator;
